import { JSX, HTMLAttributes } from "react"

import "./sprites.css"

type Props = {
  type: "orc" | "soldier"
  sprite: string
} & HTMLAttributes<HTMLSpanElement>

export default function Sprite({ type, sprite, ...rest }: Props): JSX.Element {
  return <span className={`${type} ${sprite}`} {...rest} />
}
